import React from 'react';
import styled from 'styled-components';

const HomeContainer = styled.div`
    padding: 2rem 10rem;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        flex-direction: column;
        padding: 2.5rem 0;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const MainImage = styled.img`
    width: 80%;
    height: auto;
    border-radius: 8px;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        margin-top: 10px;
        width: 100%;
    }
`;

const Home: React.FC = () => {
    return (
        <HomeContainer>
            <ImageContainer>
                <MainImage src={`${process.env.PUBLIC_URL}/main.jpg`} alt="Main Image"/>
            </ImageContainer>
            {/*<p>This is the home page content.</p>*/}
        </HomeContainer>
    );
};

export default Home;